module.exports = __webpack_public_path__ + "static/media/collection.2093aaaf.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Home/collection.png
// module id = 551
// module chunks = 0